import React, { useState, useEffect } from "react";
import { Container, Button, Accordion, Card, CardGroup } from "react-bootstrap";
import {
  faPencil,
  faMagnifyingGlass,
  faPaperclip,
  faBookBookmark,
  faTag,
  faPrescription,
  faMoneyBill,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
function Incentives() {
  const [incentives, setIncentives] = useState([]);

  useEffect(() => {
    // make an API call to retrieve incentives from backend
    const fetchIncentives = () => {
      fetch(`${process.env.REACT_APP_API_URL_PROD}/api/incentives`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((respn) => respn.json())
        .then((resp) => {
          setIncentives(resp);
        })
        .catch((error) => console.log(error));
    };

    fetchIncentives();
  }, []);

  return (
    <div>
      <Container style={{ marginTop: "5%", marginBottom: "5%" }}>
        <h2>Tax Credits for Solar Developers</h2>
        <br></br>
        <p>
          The Inflation Reduction Act includes some two dozen tax provisions
          that will save households and businesses money and accelerate the
          deployment of clean energy, clean vehicles, clean buildings, and clean
          manufacturing. As a solar developer, you can now transfer your tax
          credits in exchange for cash instead of forming a traditional tax
          equity deal which takes time and lots of resources. The table below
          provides the key information about these tax provisions and links to
          the latest announcements related to their implementation.{" "}
          <a href="https://www.whitehouse.gov/cleanenergy/clean-energy-tax-provisions/">
            Source
          </a>
        </p>
        {incentives.map((incentive, i) => {
          return (
            <div>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey={i}>
                  <Accordion.Header>{incentive.provision}</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      <b>Incentive:</b> {incentive.description}
                    </p>
                    <p>
                      <b>Funding mechanism:</b> {incentive.funding_mechanism}
                    </p>
                    <p>
                      <b>Eligibility:</b> {incentive.eligible_recipients}
                    </p>
                    <p>
                      <b>Base credit amount:</b> {incentive.base_credit_amt}
                    </p>
                    <p>
                      <b>Bonus credit amount:</b> {incentive.bonus_credit_amt}
                    </p>
                    <p>
                      {incentive.us_code} (IRA Section {incentive.ira_section})
                    </p>
                    <a
                      href={incentive.more_info_url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Button className="btn-hover color-1">
                        <FontAwesomeIcon
                          icon={faBookBookmark}
                        ></FontAwesomeIcon>{" "}
                        Learn More
                      </Button>
                    </a>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          );
        })}
      </Container>

      {/* TODO: add resource section */}
      {/* <Container>
        <h2>Resources</h2>
      </Container> */}
    </div>
  );
}

export default Incentives;
